// Helpers for reading the AHP `toolInput` union.

import type {ToolInput} from '@microsoft/agent-host-protocol'

/**
 * Narrow an AHP `toolInput` to its inline string form.
 *
 * Since protocol 0.7.0 `toolInput` is a `ToolInput` union: either the inline
 * string (the arguments as a JSON string) or a `ContentRef` pointing at input
 * held as a separate resource. `copilotd` only ever sends the inline form, and
 * every consumer here parses or renders the input synchronously, so a
 * reference is reported as absent rather than fetched.
 *
 * An empty string is also reported as absent. No caller can use one — each
 * either `JSON.parse`s the result (`''` throws) or falls back with `||` — and
 * collapsing it here keeps the value nullish so the runtime's
 * `toolInput ?? call.deltas` fallback still reaches the streamed deltas
 * instead of being short-circuited by a blank payload.
 */
export function inlineToolInput(input: ToolInput | undefined): string | undefined {
  return typeof input === 'string' && input !== '' ? input : undefined
}
